<template>
  <div class="tt-list-wrap">
    <!-- 채널 -->
    <div class="tt-logo">
      <a @click.prevent="moveToLive(data.channelid)" href="#">
        <img :src="url(data.channelimage)" :alt="data.channelname"/>
      </a>
    </div>
    <!-- 프로그램 -->
    <schedule-program v-for="(item, index) in dataList"
                      :channel-name="data.channelname"
                      :data="item"
                      :index="chIndex + '-' + index"
                      :selectYear="selectYear"
                      :selectDate="selectDate"
                      :activeTime="activeTime"
                      :key="index"
                      :channel-id="data.channelid"/>
  </div>
</template>

<script>
import ScheduleProgram from '@/components/schedule/ScheduleProgram'
import { url } from '@/common/filters/url.filter'
import { getDateFromTimeString } from '@/common/utils/common'
import { PATH_NAME_PLAYER_LIVE } from '@/common/resources/router.const'
import { resizeThumbnail } from '@/common/utils/image'

export default {
  components: {
    ScheduleProgram
  },
  props: {
    data: {
      type: Object
    },
    chIndex: {
      type: Number
    },
    selectYear: {
      type: Number
    },
    selectDate: {
      type: String
    },
    activeTime: {
      type: Number
    },
    endTime: {
      type: String
    }
  },
  data () {
    return {
      dataList: []
    }
  },
  methods: {
    url (url) {
      return resizeThumbnail(url, { width: 0, height: 0, option: 20, quality: 80 })
    },
    moveToLive (channelId) {
      this.$router.push({
        name: PATH_NAME_PLAYER_LIVE,
        query: {
          channelid: channelId
        }
      })
    }
  },
  created () {
    let prevTime = getDateFromTimeString(this.selectYear + '-' + this.selectDate + ' ' +
      (this.activeTime - 1) + ':00')
    let nextTime = getDateFromTimeString(this.selectYear + '-' + this.selectDate + ' ' +
      (this.activeTime + 1) + ':00')
    let broadcastTime = 0
    let arrayCnt = 0
    let noCnt = 0

    if (this.data.list.length <= 0) {
      let data = {
        title: '방송정보가 없습니다.',
        isBroadcast: 'n',
        broadcastTime: 120
      }
      this.dataList.push(data)
      return
    }

    for (let i = 0; i < this.data.list.length; i++) {
      url()
      let sTimeP = getDateFromTimeString(this.data.list[i].starttime)
      let eTimeP = getDateFromTimeString(this.data.list[i].endtime)
      let endTime = getDateFromTimeString(this.endTime)
      let starttimeP = sTimeP / (1000 * 60)
      let endtimeP = eTimeP / (1000 * 60)
      if (endTime < eTimeP) {
        eTimeP = endTime
      }
      let starttimeC = 0
      let direction = ''
      let data = {}

      // 다음 방송 비교대상
      if (this.data.list[i + 1] !== undefined) {
        starttimeC = new Date(this.data.list[i + 1].starttime) / (1000 * 60)
      }

      // 방송 방영 시간
      if (starttimeP < prevTime / (1000 * 60)) {
        broadcastTime = (eTimeP.getTime() - prevTime.getTime())
      } else if (endtimeP > nextTime / (1000 * 60)) {
        broadcastTime = (eTimeP.getTime() - sTimeP.getTime())
      } else {
        broadcastTime = (eTimeP.getTime() - sTimeP.getTime())
      }

      // 처음 방송시간이 없을 때
      if (starttimeP > prevTime / (1000 * 60) && i === 0) {
        data = {
          title: '방송정보가 없습니다.',
          isBroadcast: 'n',
          broadcastTime: starttimeP - (prevTime / (1000 * 60))
        }
        this.dataList.push(data)
        noCnt++
        arrayCnt++
      }

      this.dataList.push(this.data.list[i])
      this.dataList[arrayCnt].broadcastTime = broadcastTime / (1000 * 60)

      // 팝업 위치
      let time = 60
      if (time > endtimeP - (prevTime / (1000 * 60))) {
        direction = 'tt-pop-left'
      } else {
        direction = 'tt-pop-right'
      }
      this.dataList[arrayCnt].direction = direction
      arrayCnt++

      // 방송시간 없을 때
      if (endtimeP !== starttimeC && noCnt === 0) {
        if (starttimeC === 0) {
          data = {
            title: '방송정보가 없습니다.',
            isBroadcast: 'n',
            broadcastTime: (nextTime / (1000 * 60)) - endtimeP
          }
        } else {
          data = {
            title: '방송정보가 없습니다.',
            isBroadcast: 'n',
            broadcastTime: starttimeC - endtimeP
          }
        }
        this.dataList.push(data)
        noCnt++
        arrayCnt++
      }
    }
  }
}
</script>
